import React from 'react'
import { Container, Row, Col, Card, ListGroup } from "react-bootstrap";
import mobileImg from './../../Images/cour1.PNG'; // 👉 replace with your mobile image
import Footer from '../Footer';
import Enquiry from '../enquiry';
import { Helmet } from 'react-helmet';

const FullStackMobile = () => {
    return (
        <>
            <Helmet>
                <title>Mobile Full Stack Course in Coimbatore | GT SOFTWARE ACADEMY</title>
                <meta
                    name="description"
                    content="GT SOFTWARE ACADEMY in Coimbatore offers the best Mobile Full Stack training program with Android, iOS, Flutter, React Native, Dart, Java, Kotlin, SQL, NoSQL, REST APIs, real-time projects, and placement support. Designed for students, professionals, and aspiring developers to become job-ready Mobile Full Stack developers."
                />
                <meta
                    name="keywords"
                    content="
Mobile, Mobile Full Stack, Full Stack Mobile, Mobile Developer, Mobile App Development, Mobile Programming, Mobile Course, Mobile Training, Mobile Certification, Mobile Bootcamp, Mobile Online Training, Mobile Projects, Real-time Mobile, Hands-on Mobile, Mobile Case Studies, Android, iOS, Flutter, React Native, Dart, Java, Kotlin, REST API, Mobile Frameworks, Mobile Backend, Mobile Frontend, App Development, Software Development, Backend Development, Frontend Development, Fullstack Development, Mobile Applications, Cloud Deployment, Secure Mobile Apps, Authentication, Authorization, Microservices, API Integration, SQL, MySQL, PostgreSQL, NoSQL, MongoDB, Git, GitHub, Version Control, Deployment, CI/CD, Agile, Scrum, DevOps, Mobile Career, Mobile Jobs, Mobile Internship, Mobile Placement, Job-Ready Mobile, Industry Experts, Project Based Mobile, Professional Mobile Developer, Certified Mobile Developer, Career in Mobile, Mobile Mentors, Instructor Led Mobile Training, Best Mobile Institute, Top Mobile Training, Comprehensive Mobile Curriculum, End-to-End Mobile Development, Real-world Mobile Projects, Scalable Mobile Applications, Secure Mobile Applications, Mobile Cloud, Mobile Debugging, Mobile Monitoring, Mobile Apps, Mobile Social Media App, Mobile E-commerce Project, Mobile Project Management, Industry Ready Mobile Developer, Mobile Career Growth, Mobile Salary, Mobile Development Program, Full Course Mobile, GT SOFTWARE ACADEMY, GTSoftware, GTCollege, Training Institute, Coimbatore, Tamil Nadu, India, Students, Beginners, Professionals, Engineers, Developers
"
                />
                <meta
                    property="og:title"
                    content="Mobile Full Stack Course in Coimbatore | GT SOFTWARE ACADEMY"
                />
                <meta
                    property="og:description"
                    content="Master Mobile Full Stack Development with GT SOFTWARE ACADEMY, Coimbatore. Learn Android, iOS, Flutter, React Native, Dart, Java, Kotlin, SQL, APIs, cloud deployment, and real-world projects with job-oriented training and placement assistance."
                />
                <meta
                    property="og:image"
                    content="https://gtcollege.in/path-to-image/mobile-fullstack-course.PNG"
                />
                <meta property="og:type" content="website" />
                <meta name="robots" content="index, follow" />
                <link rel="canonical" href="https://www.gtcollege.in/info-mobile_full_stack" />

            </Helmet>

            <Container className="py-5">

                {/* Intro */}
                <Row className="mb-5 justify-content-center text-center">
                    <Col md={12} lg={12}>
                        <h2 className="fw-bold mb-3">Welcome to GT SOFTWARE ACADEMY</h2>
                        <p className="text-muted">
                            At <strong>GT SOFTWARE ACADEMY</strong>, we offer a comprehensive and immersive
                            <strong> Full Stack Mobile Development </strong> program, designed to equip aspiring
                            developers with the skills needed to build robust and scalable mobile applications from scratch.
                            Our curriculum covers every aspect of mobile full-stack development, including
                            <strong> Android, iOS, Flutter, React Native, backend integration, and deployment </strong>,
                            ensuring you become a job-ready Mobile Full Stack Developer.
                        </p>
                    </Col>

                </Row>

                {/* Why Full Stack Mobile Development */}
                <Row className="mb-5 lg e1" >
                    <Col md={6}>
                        <img
                            src={mobileImg}
                            style={{ height: "200px" }}
                            className="a33"
                            alt="Full Stack Mobile Development"
                        />
                    </Col>
                    <Col md={6} className="d-flex align-items-center">
                        <div>
                            <h3 className="fw-bold mb-3" style={{ color: "#7FB300" }}>
                                Why Choose Full Stack Mobile Development?
                            </h3>
                            <p style={{ color: "white" }}>
                                Mobile applications are driving innovation and transforming businesses worldwide.
                                A <strong>Full Stack Mobile Developer</strong> is capable of designing and building both
                                the <strong>front-end</strong> (user interface) and <strong>back-end</strong> (server, database, and APIs)
                                of mobile apps. This skillset makes them highly valuable in the tech industry, enabling
                                end-to-end development of <strong>Android</strong>, <strong>iOS</strong>, and cross-platform
                                applications using frameworks like <strong>Flutter</strong> and <strong>React Native</strong>.
                            </p>
                        </div>
                    </Col>

                </Row>

                {/* What You'll Learn */}
                <Row className="mb-5">
                    <Col>
                        <h3 className="fw-bold text-center mb-4">What You'll Learn in Full Stack Mobile Development</h3>
                    </Col>
                </Row>
                <Row>
                    <Col md={6} className="mb-4">
                        <Card className="rounded-2 h-100 shadow-sm">
                            <Card.Body>
                                <Card.Title className="fw-bold">1. Front-End Mobile Development</Card.Title>
                                <ListGroup variant="flush">
                                    <ListGroup.Item className="border-0 ps-0">🌍 Create engaging, interactive, and user-friendly mobile interfaces</ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">⚡ Design responsive layouts for Android and iOS devices</ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">🧩 Apply best practices in UI/UX for mobile apps</ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">📱 Use modern frameworks like React Native & Flutter for cross-platform apps</ListGroup.Item>
                                </ListGroup>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={6} className="mb-4">
                        <Card className="rounded-2 h-100 shadow-sm">
                            <Card.Body>
                                <Card.Title className="fw-bold">2. Back-End Mobile Development</Card.Title>
                                <ListGroup variant="flush">
                                    <ListGroup.Item className="border-0 ps-0">🌍 Learn server-side programming for mobile apps</ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">🧩 Design, build, and manage databases (SQL & NoSQL)</ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">⚡ Understand and implement RESTful APIs</ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">🔑 Implement authentication, authorization, and mobile app security best practices</ListGroup.Item>
                                </ListGroup>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={6} className="mb-4">
                        <Card className="rounded-2 h-100 shadow-sm">
                            <Card.Body>
                                <Card.Title className="fw-bold">3. Mobile App Deployment & Testing</Card.Title>
                                <ListGroup variant="flush">
                                    <ListGroup.Item className="border-0 ps-0">🏗️ Publish apps to Google Play Store & Apple App Store</ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">🛠️ Debug, troubleshoot, and optimize app performance</ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">📊 Test apps across devices for smooth user experience</ListGroup.Item>
                                </ListGroup>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={6} className="mb-4">
                        <Card className="rounded-2 h-100 shadow-sm">
                            <Card.Body>
                                <Card.Title className="fw-bold">4. Real-World Projects & Case Studies</Card.Title>
                                <ListGroup variant="flush">
                                    <ListGroup.Item className="border-0 ps-0">🛡️ Build fully functional, industry-standard mobile apps</ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">⚡ Work on projects simulating actual development workflows</ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">🌍 Collaborate with peers and mentors for hands-on learning</ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">💼 Prepare a portfolio of projects to showcase to employers</ListGroup.Item>
                                </ListGroup>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Enquiry />
                </Row>
                {/* Why Choose Us */}
                {/* <Row className="mt-5">
                    <Col>
                        <h3 className="fw-bold text-center mb-4">Why Choose Us?</h3>
                    </Col>
                </Row>
                <Row className="mt-5 text-center">
                    <Col md={3} className="mb-4">
                        <Card className="h-100 shadow-sm border-0.5 rounded-3">
                            <Card.Body>
                                <h2>👨‍🏫</h2>
                                <h5 className="fw-bold mt-2">Expert-Led Training</h5>
                                <p className="text-muted">
                                    Learn from seasoned professionals who have years of real-world experience
                                    in mobile app development.
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={3} className="mb-4">
                        <Card className="h-100 shadow-sm border-0.5 rounded-3">
                            <Card.Body>
                                <h2>💻</h2>
                                <h5 className="fw-bold mt-2">Practical Hands-On Learning</h5>
                                <p className="text-muted">
                                    We believe in learning by doing. Our projects and case studies will ensure
                                    you develop practical skills that you can apply immediately.
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={3} className="mb-4">
                        <Card className="h-100 shadow-sm border-0.5 rounded-3">
                            <Card.Body>
                                <h2>🏗️</h2>
                                <h5 className="fw-bold mt-2">Industry-Relevant Curriculum</h5>
                                <p className="text-muted">
                                    Our curriculum is designed to keep pace with the rapidly evolving mobile
                                    development landscape, ensuring you are always up to date.
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={3} className="mb-4">
                        <Card className="h-100 shadow-sm border-0.5 rounded-3">
                            <Card.Body>
                                <h2>🚀</h2>
                                <h5 className="fw-bold mt-2">Job-Ready Skills</h5>
                                <p className="text-muted">
                                    Our program is designed to make you job-ready. Upon completion, you'll have
                                    the expertise to develop, deploy, and maintain mobile applications from start
                                    to finish.
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row> */}
                <Row className="mt-5">
                    <Col>
                        <h3 className="fw-bold text-center mb-4">Why Choose GT SOFTWARE ACADEMY for Mobile Development?</h3>
                    </Col>
                </Row>
                <Row className="mt-5 text-center">
                    <Col md={3} className="mb-4">
                        <Card className="h-100 shadow-sm border-0 rounded-3">
                            <Card.Body>
                                <h2>👨‍🏫</h2>
                                <h5 className="fw-bold mt-2">Expert-Led Training</h5>
                                <p className="text-muted">
                                    Learn from seasoned professionals with extensive real-world experience in mobile app development, React Native, Flutter, and backend technologies.
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={3} className="mb-4">
                        <Card className="h-100 shadow-sm border-0 rounded-3">
                            <Card.Body>
                                <h2>💻</h2>
                                <h5 className="fw-bold mt-2">Hands-On Practical Learning</h5>
                                <p className="text-muted">
                                    Gain real-world skills through projects, case studies, and exercises, building apps that you can showcase in your portfolio.
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={3} className="mb-4">
                        <Card className="h-100 shadow-sm border-0 rounded-3">
                            <Card.Body>
                                <h2>🏗️</h2>
                                <h5 className="fw-bold mt-2">Industry-Relevant Curriculum</h5>
                                <p className="text-muted">
                                    Our curriculum stays up-to-date with the latest mobile development trends, frameworks, and best practices, ensuring you learn what employers want.
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={3} className="mb-4">
                        <Card className="h-100 shadow-sm border-0 rounded-3">
                            <Card.Body>
                                <h2>🚀</h2>
                                <h5 className="fw-bold mt-2">Job-Ready Skills & Career Support</h5>
                                <p className="text-muted">
                                    Complete the program ready to develop, deploy, and maintain mobile applications, with mentorship and placement support to kickstart your career.
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

            </Container>
            <Footer />
        </>
    )
}

export default FullStackMobile;
